import api from '../../../core/api/client';

const toApiError = (error) => {
  if (error?.response) {
    const d = error.response.data;
    return {
      status:  error.response.status,
      message: d?.detail || d?.message || d?.error || error.message || 'Request failed',
      data:    d,
    };
  }
  return { status: 0, message: error?.message || 'Unexpected error', data: null };
};

const wrap = async (fn) => {
  try { return await fn(); }
  catch (error) { throw toApiError(error); }
};

export const reportsService = {
  async getTeamActivity({ from, to, userIds } = {}) {
    return wrap(async () => {
      const params = {};
      if (from) params.from = from;
      if (to)   params.to   = to;
      if (userIds?.length) params.userIds = userIds;
      const res = await api.get('/reports/team/activity', { params });
      return res.data;
    });
  },

  async getTimeline({ projectId } = {}) {
    return wrap(async () => {
      const params = {};
      if (projectId) params.projectId = projectId;
      const res = await api.get('/reports/timeline', { params });
      return res.data;
    });
  },
};
